import './App.css';
import { Navigate, Routes, Route } from "react-router-dom";
import Page404 from './layout/Page404';
import Login from './layout/Login';

import Dashboard from './components/Dashboard/Dashboard'
import UserMaster from './components/UserMaster/UserMaster'
import CurrencyMaster from './components/MasterData/CurrencyMaster'

import RoleMaster from './components/RoleMaster/RoleMaster'
import DocumentNumbering from './components/DocumentNumbering/DocumentNumbering'
import Alerts from './components/Alerts/Alerts'
import ChangePassword from './components/ChangePassword/ChangePassword'
import CompanyMaster from './components/CompanyDetails/CompanyMaster'
import PaymentTermMaster from './components/MasterData/PaymentTermMaster'
import UomMaster from './components/MasterData/UomMaster'
import FinancialYearMaster from './components/MasterData/FinancialYearMaster'
import SubsidyCompanyMaster from './components/MasterData/SubsidyCompanyMaster'
import ProjectMaster from './components/MasterData/ProjectMaster'
import CostCenterCreation from './components/MasterData/CostCenterCreation'
import AccountList from './components/AccountCreation/AccountsList'
import SalesQuotationPage from './components/Sales/SalesQuotation'
import SalesOrder from './components/Sales/SalesOrder'
import SalesARInvoice from './components/Sales/arInvoice/SalesARInvoice'
import SalesDeliveryOrder from './components/Sales/deliveryOrder/SalesDeliveryOrder'
import SalesQuotationCreatePage from './components/Sales/SalesQuotationCreate'

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/404" element={<Page404 />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/usermaster" element={<UserMaster />} />
        {/* <Route path="/rolemaster" element={<RoleMaster />} /> */}
        {/* <Route path="/document-numbering" element={<DocumentNumbering />} /> */}
        {/* <Route path="/alerts" element={<Alerts />} /> */}
        {/* <Route path="/change-password" element={<ChangePassword />} /> */}
        <Route path="/company-master" element={<CompanyMaster />} />
        <Route path="/payment-term-master" element={<PaymentTermMaster />} />
        <Route path="/currency-master" element={<CurrencyMaster />} />
        <Route path="/uom-master" element={<UomMaster />} />
        <Route path="/financial-year-master" element={<FinancialYearMaster />} />
        <Route path="/subsidy-company-master" element={<SubsidyCompanyMaster />} />
        <Route path="/project-master" element={<ProjectMaster />} />
        <Route path="/cost-center-creation" element={<CostCenterCreation />} />
        <Route path="/sales-quotation" element={<SalesQuotationPage />} />
        <Route path="/sales-quotation-create" element={<SalesQuotationCreatePage />} />
        <Route path="/sales-quotation-update/:quote_id" element={<SalesQuotationCreatePage />} />
        <Route path="/sales-order" element={<SalesOrder />} />
        <Route path="/sales-ar-invoice" element={<SalesARInvoice />} />
        <Route path="/sales-delivery-order" element={<SalesDeliveryOrder />} />
        <Route path="/account-list" element={<AccountList />} />

        <Route path="*" element={<Page404 />} />
      </Routes>
    </div>
  );
}

export default App;
